import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as d from "react";
import { T as y } from "./Text.BGhoO_e3.js";
import { F, d as R, a as T } from "./FunctionalCard.DP-yCR_u.js";
import { C as N, b as g, a as b } from "./ExpandableContent.Cw-_R4is.js";
import { P as O, d as $, c as k, a as A, b as B } from "./Popover.IWkkIIzd.js";
import { F as D, P as E } from "./PriceLineItemTooltipTitle.BDwjLtsr.js";
import { F as W } from "./ChevronDown16.BcSr2mQh.js";
import { F as q } from "./ChevronDown20.NQYj4T82.js";
import { F as z } from "./X16.DHZc2Acw.js";
import { c as w } from "./index.CxSWpsOB.js";
import { D as H } from "./Divider.CmCxrw3f.js";
const v = ({
  rowIndex: s,
  isTotalRow: a
}) => {
  const e = s && s % 3;
  return /* @__PURE__ */ t.jsxs("div", { className: "tw-flex tw-gap-32 tw-justify-between", children: [
    /* @__PURE__ */ t.jsx("div", { className: w("tw-h-16 tw-bg-gray-200 tw-animate-pulse tw-flex-initial", {
      "tw-w-[68%] tw-max-w-[140px]": e === 0,
      "tw-w-[62%] tw-max-w-[106px]": e === 1,
      "tw-w-[64%] tw-max-w-[128px]": e === 2,
      "tw-w-[58%] tw-max-w-[71px]": a
    }) }),
    /* @__PURE__ */ t.jsx("div", { className: w("tw-h-16 tw-bg-gray-200 tw-animate-pulse tw-flex-initial", {
      "tw-w-[32%] tw-max-w-[85px]": e === 0,
      "tw-w-[38%] tw-max-w-[50px]": e === 1,
      "tw-w-[36%] tw-max-w-[71px]": e === 2,
      "tw-w-[42%] tw-max-w-[50px]": a
    }) })
  ] });
}, L = ({
  totalRows: s = 3
}) => /* @__PURE__ */ t.jsxs("div", { className: "tw-space-y-16 tw-w-full", children: [
  [...Array(s)].map((a, e) => /* @__PURE__ */ t.jsx(v, { rowIndex: e }, `price-summary-skeleton-${e}`)),
  /* @__PURE__ */ t.jsx(H, {}),
  /* @__PURE__ */ t.jsx(v, { isTotalRow: !0 })
] }), f = d.createContext({
  spacing: 12,
  textSize: "normal"
}), V = d.forwardRef(({
  children: s,
  lineItems: a,
  total: e,
  caption: l,
  footer: r,
  textSize: n = "normal",
  className: p,
  footerClassName: o,
  showSkeleton: h = !1,
  spacing: i = 12,
  testId: m,
  title: c
}, j) => h ? /* @__PURE__ */ t.jsx(L, {}) : /* @__PURE__ */ t.jsx(f.Provider, { value: {
  spacing: i,
  textSize: n
}, children: /* @__PURE__ */ t.jsxs("div", { "data-testid": m, ref: j, children: [
  c && /* @__PURE__ */ t.jsx(_, { children: c }),
  /* @__PURE__ */ t.jsxs("div", { className: w("tw-flex tw-flex-col", {
    "tw-body-1": n === "normal",
    "tw-body-2": n === "large",
    "tw-gap-4": i === 4,
    "tw-gap-8": i === 8,
    "tw-gap-12": i === 12,
    "tw-gap-16": i === 16
  }, p), children: [
    s || (a || []).map((x, S) => /* @__PURE__ */ t.jsx(u, { ...x }, S)),
    e && /* @__PURE__ */ t.jsx(I, { ...e }),
    r && /* @__PURE__ */ t.jsx(C, { className: o, children: r }),
    l && /* @__PURE__ */ t.jsx(P, { children: l })
  ] })
] }) }));
V.displayName = "PriceSummary";
const _ = ({
  children: s,
  className: a
}) => /* @__PURE__ */ t.jsx(y, { element: "div", typeface: "headline-1-m", className: w("tw-mb-16", a), children: s }), C = ({
  children: s,
  className: a
}) => /* @__PURE__ */ t.jsx("div", { className: w("tw-text-left tw-caption-2 tw-text-gray-600 tw-border-t-0", a), children: s });
C.displayName = "PriceSummaryFooter";
const P = ({
  children: s,
  className: a
}) => {
  const {
    spacing: e
  } = d.useContext(f);
  return /* @__PURE__ */ t.jsx("div", { className: w("tw-text-left tw-border-t tw-border-gray-300 tw-caption-2", {
    "tw-pt-8": e === 8,
    "tw-pt-12": e === 12,
    "tw-pt-16": e === 16
  }, a), children: s });
};
P.displayName = "PriceSummaryCaption";
const G = ({
  title: s,
  content: a,
  className: e,
  closeButton: l
}) => /* @__PURE__ */ t.jsxs(F, { className: w("tw-border-0 tw-w-full sm:tw-w-[225px]", e), children: [
  s && /* @__PURE__ */ t.jsx(R, { className: "sm:tw-border-b-0", closeButton: l || /* @__PURE__ */ t.jsx(B, { children: /* @__PURE__ */ t.jsx(z, {}) }), children: /* @__PURE__ */ t.jsx(y, { typeface: "body-1-m", children: s }) }),
  /* @__PURE__ */ t.jsx(T, { className: "sm:tw-pt-8", children: /* @__PURE__ */ t.jsx(y, { element: "div", typeface: "body-1", className: "tw-text-gray-900", children: a }) })
] }), u = ({
  name: s,
  value: a,
  description: e,
  variant: l,
  border: r,
  testId: n,
  className: p,
  tooltip: o,
  ...h
}) => {
  const {
    spacing: i
  } = d.useContext(f), m = r === "top" || r === "both", c = r === "bottom" || r === "both", [j, x] = d.useState(!1);
  return /* @__PURE__ */ t.jsxs("div", { className: w("tw-grid tw-grid-cols-3 tw-border-0 tw-border-gray-300 tw-gap-8", {
    "tw-border-t": r === "top",
    "tw-border-b": r === "bottom",
    "tw-border-t tw-border-b": r === "both",
    "tw-pt-8": i === 8 && m,
    "tw-pt-12": i === 12 && m,
    "tw-pt-16": i === 16 && m,
    "tw-pb-8": i === 8 && c,
    "tw-pb-12": i === 12 && c,
    "tw-pb-16": i === 16 && c
  }, p), ...h, children: [
    /* @__PURE__ */ t.jsxs("div", { className: "tw-col-span-2", "data-testid": n ? `${n}-name` : void 0, children: [
      o ? /* @__PURE__ */ t.jsxs(O, { open: j, onOpenChange: x, isResponsive: !0, children: [
        /* @__PURE__ */ t.jsx($, { className: "tw-text-left", children: /* @__PURE__ */ t.jsxs("span", { className: "tw-underline sm:tw-no-underline tw-inline-flex tw-items-center tw-gap-4", children: [
          /* @__PURE__ */ t.jsx("span", { children: s }),
          /* @__PURE__ */ t.jsx(D, { className: "tw-hidden sm:tw-block tw-min-w-16", name: "question-mark" })
        ] }) }),
        /* @__PURE__ */ t.jsxs(k, { align: "start", side: "top", className: "tw-min-h-[193px] sm:tw-min-h-0", children: [
          o.renderContent ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
            o.title && /* @__PURE__ */ t.jsx(E, { children: o.title }),
            o.renderContent(x)
          ] }) : /* @__PURE__ */ t.jsx(G, { title: o.title, content: o.content }),
          /* @__PURE__ */ t.jsx(A, { className: "tw-fill-base-white" })
        ] })
      ] }) : s,
      e && /* @__PURE__ */ t.jsx("div", { className: "tw-caption-2 tw-text-gray-600", children: e })
    ] }),
    /* @__PURE__ */ t.jsx("div", { className: w("tw-text-right tw-col-span-1", {
      "tw-text-green-800": l === "highlight"
    }), "data-testid": n ? `${n}-value` : void 0, children: a })
  ] });
};
u.displayName = "PriceSummaryRow";
const at = ({
  expandableContent: s,
  expandableContentClassName: a,
  showCaret: e = !0,
  caretPosition: l = "left",
  name: r,
  value: n,
  ...p
}) => {
  const [o, h] = d.useState(!1), {
    textSize: i
  } = d.useContext(f), m = e ? /* @__PURE__ */ t.jsx("span", { className: "tw-flex tw-items-center", children: i === "normal" ? /* @__PURE__ */ t.jsx(W, { name: "chevron-down", className: w({
    "tw-rotate-180": o
  }) }) : /* @__PURE__ */ t.jsx(q, { name: "chevron-down", className: w({
    "tw-rotate-180": o
  }) }) }) : null, c = () => l === "left" ? /* @__PURE__ */ t.jsxs(g, { className: "tw-text-left tw-flex tw-gap-8 tw-items-start", children: [
    m,
    /* @__PURE__ */ t.jsx("span", { children: r })
  ] }) : l === "contentRight" ? /* @__PURE__ */ t.jsxs(g, { className: "tw-text-left tw-flex tw-gap-8 tw-items-start", children: [
    /* @__PURE__ */ t.jsx("span", { children: r }),
    m
  ] }) : r, j = () => l === "right" ? /* @__PURE__ */ t.jsxs("div", { className: "tw-flex tw-gap-8 tw-items-start tw-justify-end", children: [
    /* @__PURE__ */ t.jsx("span", { children: n }),
    m
  ] }) : n, x = e && l === "left" ? "tw-pl-28" : void 0;
  return l === "right" ? /* @__PURE__ */ t.jsxs(N, { onOpenChange: h, children: [
    /* @__PURE__ */ t.jsx(g, { className: "tw-w-full tw-text-left", children: /* @__PURE__ */ t.jsx(u, { ...p, name: c(), value: j() }) }),
    /* @__PURE__ */ t.jsx(b, { shouldAnimate: !0, children: /* @__PURE__ */ t.jsx("div", { className: w(x, a), children: s }) })
  ] }) : /* @__PURE__ */ t.jsxs(N, { onOpenChange: h, children: [
    /* @__PURE__ */ t.jsx(u, { ...p, name: c(), value: n }),
    /* @__PURE__ */ t.jsx(b, { shouldAnimate: !0, children: /* @__PURE__ */ t.jsx("div", { className: w(x, a), children: s }) })
  ] });
}, I = ({
  variant: s,
  className: a,
  name: e = "Total",
  ...l
}) => {
  const {
    textSize: r,
    spacing: n
  } = d.useContext(f);
  return /* @__PURE__ */ t.jsx(u, { border: "top", name: e, ...l, className: w({
    "tw-mt-12 tw-pt-16": n === 4,
    "tw-mt-8 tw-pt-16": n === 8,
    "tw-mt-4 tw-pt-16": n === 12,
    "tw-body-1-m": r === "normal",
    "tw-body-2-m": r === "large",
    "tw-text-green-800": s === "highlight"
  }, a) });
};
export {
  V as P,
  u as a,
  P as b,
  C as c,
  at as d,
  G as e,
  _ as f,
  I as g,
  L as h
};
//# sourceMappingURL=PriceSummary.DZSKRE8t.js.map
